module.exports = {
  "下载":"تنزيل",
  "打开":"فتح",
  language: {
    "name":"简体中文",
    "title":"选择语言",
    subList: [
      {
        name:"English",
        link:"en",
      },
      // {
      //   name:"简体中文",
      //   link:"zh",
      // },
      {
          name:"繁體中文",
          link:"tw",
      },
      {
        name:"日本語",
        link:"jp",
      },
      {
        name:"한국어",
        link:"kr",
      },
      {
        name:"ไทย",
        link:"th",
      },
      {
        name:"Tiếng Việt",
        link:"vn",
      },
      {
        name:"Español",
        link:"es",
      },
      {
        name: 'Deutsch',
        link: 'de',
      },
      {
        name: 'Français',
        link: 'fr',
      },
      {
        name: 'Italia',
        link: 'it',
      },
      {
        name: 'Portugal',
        link: 'pt',
      },
      {
        name: 'Расея',
        link: 'ru',
      },
      {
        name: 'عربي',
        link: 'ar',
      },
    ]
  },
  "user":{//my
    "wdtd":"فريقي",
    "wdyj":"أدائي",
    "ren":"الشخص",
  },
  "kjsy": {
    "title":"الإيرادات",
    "fxsy":"حصة الإيرادات",
    "zjlsl":"إجمالي مبلغ المكافأة",
    "jl":"المكافأة",
    "sj":"التاريخ",
    "sl":"الكمية",
    "sm":"الوصف",
  },
  pay:{//purchase
    "title":"شراء آلة التعدين",
    "gmsl":"كمية الشراء",
    "zf":"الدفع",
    "kyye":"الرصيد المتاح",
    "kyyebz":"الرصيد المتاح غير كافٍ",
    "bztbtips":"مبلغ السحب المدخل أقل من الحد الأدنى لمتطلبات السحب لهذه العملة",
    "bztbtips2":"لا يمكن أن يكون مبلغ السحب أقل من الحد الأدنى للسحب",
    "qsrjymm":"يرجى إدخال كلمة مرور للمعاملة مكونة من 6 أرقام",
    "wxts":"تذكير",
  },
  chongbi:{
    "title":"إيداع",
    "lianmc":"نوع السلسلة",
    "scl":"إنشاء سلسلة حصرية",
    "sy":"المفتاح الخاص",
    "ewm":"رمز الاستجابة السريعة",
    "bcewm":"احفظ رمز الاستجابة السريعة",
    "cbdz":"عنوان الإيداع",
    "fz":"نسخ",
    "sl":"مبلغ الإيداع",
    "qsrsl":"الرجاء إدخال مبلغ الإيداع",
    "sjczje":"مبلغ إعادة الشحن الفعلي",
    "qsrsjczje":"الرجاء إدخال مبلغ إعادة الشحن الفعلي",
    "pzms":"وصف الشهادة",
    "qsrms":"الرجاء إدخال وصف",
    "hxz":"قيمة التجزئة",
    "qsrhxz":"الرجاء إدخال قيمة التجزئة",
    "pztp":"صورة القسيمة",
    "qscpztp":"الرجاء تحميل صورة الشهادة",
    "fzcg":"نسخ ناجح",
    "yhkcz":"إعادة شحن البطاقة المصرفية",
    "usdtcz":"إعادة شحن USDT",
    "btccz":"إعادة شحن BTC",
    "xzbz":"تحديد العملة",
    "sure":"تأكيد",
    "ck":"عرض",
    "tips1":"يرجى عدم شحن أي أصول ليست بهذه العملة إلى العنوان أعلاه وإلا فلن يمكن استرداد الأصول",
    "tips2":"1. شبكة الإرسال الخاصة بك ومنصة الهدف متسقتان؛ إذا اخترت أن يكون عنوان الهدف هو شبكة Ethereum، فيجب عليك تحديد السلسلة الذكية المقابلة عند الإرسال. إذا كان هناك خطأ، فلن تتمكن من استرداد أصولك الرقمية.",
    "tips3":"2. تأكد من أن عنوانك وشبكتك متسقان قبل الإرسال.",
    "tips4":"تذكير دافئ: نظرًا لعدم الكشف عن هويتك وخصوصية شبكة blockchain، فبمجرد إدخال معلومات غير صحيحة، ستفقد الأصول المقابلة. يرجى التأكد من التحقق مرة أخرى من عنوان الشحن الخاص بك.",
  },
  usdttb:{
    "title":"سحب",
    "lmc":"نوع السلسلة",
    "xzl":"تحديد السلسلة",
    "xztbdz":"تحديد عنوان السحب",
    "qsrtbdz":"الرجاء إدخال عنوان السحب",
    "tbdz":"عنوان السحب",
    "qsrdz":"الرجاء إدخال العنوان",
    "tbsl":"مبلغ السحب",
    "tbsl2":"مبلغ السحب",
    "qsrtbsl":"الرجاء إدخال مبلغ السحب",
    "sjtxje":"مبلغ السحب الفعلي",
    "qsrsjtxje":"الرجاء إدخال مبلغ السحب الفعلي",
    "dzje":"مبلغ الحساب",
    "jymm":"كلمة مرور المعاملة",
    "qsrjymm":"الرجاء إدخال كلمة مرور المعاملة",
    "sxf":"رسوم المعالجة",
    "qsrsxf":"الرجاء إدخال رسوم المعالجة",
    "dzsl":"مبلغ الحساب",
    "dzsl2":"مبلغ الحساب المستلم:",
    "qsrdzsl":"الرجاء إدخال مبلغ الحساب",
    "wxts":"تذكير:",
    "mrzdtxcs":"الحد الأدنى لمبلغ السحب في كل مرة:",
    "hxxf":"المطلوب استهلاكه",
    "cktx":"متاح للسحب فقط",
    "ci":"الأوقات",
    "wddtxyq":"لم يتم استيفاء متطلبات السحب",
    "tjcg":"تم الإرسال بنجاح، يرجى الانتظار للمراجعة",
    "tips":"يمكنك سحب العملات فقط إذا كانت قوة الحوسبة الخاصة بك أكبر من 1T (باستثناء قوة الحوسبة لآلة التعدين التجريبية) أو قوة الحوسبة تحت المظلة أكبر من 50T.",
    "dz":"العنوان",
    "qd":"حسنًا",
    "zdtb":"الحد الأدنى للسحب",
  },
  kefu: {
    "title":"اتصل بخدمة العملاء",
    "zxkf":"خدمة العملاء",
    "fzcg":"تم النسخ بنجاح",
  },
  xgdlmm:{//Modify login password
    "title":"تغيير كلمة مرور تسجيل الدخول",
    "t1":"كلمة مرور تسجيل الدخول الحالية",
    "t2":"يرجى إدخال كلمة مرور تسجيل الدخول الحالية",
    "t3":"كلمة مرور جديدة",
    "t4":"يرجى إدخال 6-16 رقمًا وحرفًا",
    "t5":"تأكيد كلمة المرور",
    "t6":"يرجى إدخال 6-16 رقمًا وحرفًا",
    "t7":"تأكيد",
    "t8":"كلمة المرور غير متوافقة مع كلمة مرور التأكيد",
    "mm":"كلمة المرور",
    "qsrmm":"يرجى إدخال كلمة مرورك",
    "qqrmm":"يرجى تأكيد كلمة مرورك",
    "qsrsjh":"رقم الهاتف المحمول",
    "zc":"التسجيل",
    "mmts":"طول كلمة المرور من 6 إلى 12 حرفًا",
  },
  sztxmm:{//Set withdrawal password
    "title":"تغيير كلمة مرور المعاملة",
    "wjtkmm":"نسيت كلمة مرور المعاملة",
    "qsrjdlmm":"الرجاء إدخال كلمة مرور المعاملة الحالية",
    "zh":"الحساب",
    "qsryxhzsj":"الرجاء إدخال عنوان بريدك الإلكتروني أو رقم هاتفك المحمول",
    "t1":"كلمة مرور المعاملة الحالية",
    "t2":"كلمة مرور المعاملة الجديدة",
    "t3":"الرجاء إدخال كلمة مرور المعاملة المكونة من 6 أرقام",
    "t4":"تأكيد كلمة المرور",
    "t5":"نسيت كلمة مرور المعاملة؟",
    "t6":"تأكيد",
    "t7":"كلمة المرور غير متوافقة مع كلمة مرور التأكيد",
    "t8":"كلمة مرور المعاملة",
    "yzm":"رمز التحقق",
    "qsryzm":"الرجاء إدخال رمز التحقق",
    "hqyzm":"الحصول على رمز التحقق",
  },
  record: {
    "cbjl":"سجل الإيداع",
    "tbjl":"سجل السحب",
    "status":"['لم تتم مراجعته','تم النجاح','تم رفضه']",
    "bhly":"سبب الرفض",
    "ldz":"العنوان",
    "cjsj":"وقت الإنشاء",
    "zzsj":"وقت التحويل",
    "czl":"سلسلة إعادة الشحن",
    "zrl":"سلسلة التحويل",
    "jyhx":"تجزئة المعاملة",
  },
  yqm: {
    "wdyqlj":"رابط دعوتي",
    "wdyqm":"رمز دعوتي",
    "schbyq":"إنشاء دعوة ملصقة",
    "bctp":"حفظ الصورة",
    "qx":"إلغاء",
    "fx":"مشاركة",
    "yqm":"نسخ رمز الدعوة",
    "bcewmdxc":"حفظ رمز الاستجابة السريعة في الألبوم",
    "bcbd":"حفظ محليًا",
  },
  "wdtd": {
    "title":"فريقي",
    "td":"فريق",
    "yqhy":"دعوة الأصدقاء",
    "ren":"شخص",
    "wdtdzrs":"العدد الإجمالي لفريقي",
    "uid":"معرف المستخدم:",
    "zh":"الحساب:",
    "tdrs":"حجم الفريق:",
    "zcsj":"تاريخ التسجيل:",
  },
  "wdyj": {
    "title":"أدائي",
    "wdyd":"جيلي",
    "dyj":"الأداء",
    "tdzyj":"إجمالي أداء الفريق",
    "uid":"المعرف الفريد:",
    "tdrs":"حجم الفريق:",
    "yj":"الأداء:",
  },
  "zc": {
    "title":"الأصول",
    "zzczh":"إجمالي الأصول المكافئة",
    "dh":"التبادل",
    "yczc":"الأصول مخفية كـ 0",
    "xj":"السعر الحالي",
    "zh":"محوّل",
    "zcmx":"تفاصيل الأصول",
  },
  "duihuang": {
    "title":"التبادل",
    "hl":"سعر الصرف",
    "zf":"الدفع",
    "qbdh":"التبادل الكل",
    "ky":"متاح",
    "dd":"احصل على",
    "ljdh":"استرداد الآن",
    "cont":"تغييرات سعر الصرف، وفقًا للمبلغ الفعلي المستلم",
    "yebz":"رصيد غير كافٍ",
    "ksslbz":"كمية غير كافية متوفرة",
    "qtxje":"يرجى إدخال الكمية",
    "dhcg":"التبادل ناجح",
    "mrcg":"الشراء ناجح",
    "mccg":"تم البيع بنجاح",
    "wtcg":"نجح التفويض",
    "ts":"موجه",
    "btcmTips":"وفقًا لإعدادات العقد الذكي، سيبدأ تداول USDT في GDCC في 8 أغسطس 2023.",
    "qx":"إلغاء",
  },
  "sign": {
    "title":"تسجيل الدخول لتلقي العملات",
    "title2":"مكافأة تسجيل الدخول اليومية",
    "title3":"مكافأة تسجيل الدخول",
    "qd":"تسجيل الدخول",
    "yqd":"تم تسجيل الدخول",
    "hdgz":"تفاصيل القاعدة",
    "qdjl":"سجل الدخول",
    "qdcg":"تسجيل الدخول بنجاح",
  },
  "langNew": {
    "wd":"My",
    "jd":"الاقتراض",
    "jghy":"العقود الآجلة",
    "xbsg":"شراء عملة سنغافورة",
    "sylx":"نوع الفائدة",
    "syts":"أيام الأرباح",
    "rsy":"الدخل اليومي",
    "rsy2":"الدخل اليومي",
    "yjdts":"عدد الأيام المقترضة",
    "jdsy":"دخل الإقراض",
    "jdsy2":"دخل الإقراض",
    "jdrq":"تاريخ القرض",
    "qdsy":"تسجيل الدخول الفوائد",
    "tgsy":"فوائد الترويج",
    "sybl":"نسبة الربح",
    "sybl2":"نسبة الربح",
    "ljcy":"الانضمام الآن",
    "zsy":"إجمالي دخل USDT",
    "jdrz":"عقدة الارتباط",
    "jiedian":"عقدة",
    "qsrje":"يرجى إدخال عقدة",
    "xyb":"التالي",
    "zhye":"رصيد الحساب",
    "dzye":"رصيد العنوان",
    "zhyezh":"رصيد الحساب (المكافئ)",
    "zq":"الفترة:",
    "zq2":"الفترة",
    "jdsl":"مبلغ القرض",
    "yxbd":"البريد الإلكتروني التحقق",
    "qsryxzh":"يرجى إدخال حساب بريدك الإلكتروني",
    "yxgz":"عنوان البريد الإلكتروني المدخل لا يتوافق مع القواعد",
    "jxz":"جاري التنفيذ",
    "ywc":"مكتمل",
    "day":"أيام",
    "jg":"السعر",
    "zwsj":"لا توجد بيانات~",
    "wyjb":"اقتراض",
    "fxjl":"مشاركة المكافأة",
    "aqsz":"إعدادات الأمان",
    "wded":"جيلي الثاني",
    "wdsd":"أجيالي الثلاثة",
    "dbxe":"حد المعاملة الفردية",
    "tjdd":"إرسال الطلب",
    "tqsh":"سحب الاسترداد",
    "shuhui":"الاسترداد",
    "ljdz":"عنوان الرابط",
    "yyqh":"تبديل اللغة",
    "zxkf":"خدمة العملاء",
    "syl":"الإرجاع اليومي",
    "zhuanbi":"كسب العملات",
    "zbsy":"كسب دخل العملة",
    "mc":"الاسم",
    "zxj":"أحدث سعر",
    "zfb":"القائمة الصاعدة",
    "shouye":"الصفحة الرئيسية",
    "gg":"إعلان",
    "rzz":"جاري التصديق",
    "yrz":"مُصدَّق",
    "rzsb":"فشلت عملية المصادقة، يُرجى إعادة المصادقة",
    "cxrz":"إعادة المصادقة",
    "jymmts":"يرجى تعيين كلمة مرور للمعاملة",
  },
  "xbsg":{
    "title":"عملة جديدة",
    "wdsg":"التفاصيل",
    "scts":"أيام الحظر:",
    "sy":"المتبقي",
    "ljsg":"اشترك الآن",
    "ysk":"نفد المخزون",
    "xzjdy":"اشترك الآن",
    "dy":"اشترك",
    "fxjg":"سعر الإصدار",
    "fxl":"التداول",
    "ssrq":"تاريخ الإدراج",
    "yxqx":"فترة الصلاحية",
    "qsrsl":"يرجى إدخال المبلغ",
    "syl":"المتبقي",
    "sgrq":"اشترك",
    "sgsl":"المبلغ",
    "bz":"عملة",
    "yebz":"رصيد USDT غير كافٍ",
    "tgsl":"كمية النجاح",
    "shz":"قيد المراجعة",
    "wtg":"لم ينجح",
    "ytg":"نجح",
  },
  "wydb":{
    "title":"اقتراض",
    "db":"اقتراض",
    "dbz":"اقتراض",
    "jl":"تسجيل",
    "jdzq":"الفترة (أيام)",
    "qhk":"للسداد",
    "ljdb":"التراكمي (بالدولار الأمريكي)",
    "dhkbs" :"في انتظار السداد",
    "jkje":"مبلغ القرض (بالدولار الأمريكي)",
    "qsrje":"يرجى إدخال المبلغ",
    "rll":"معدل الفائدة اليومي",
    "hkfs":"السداد",
    "dqych":"منتهية الصلاحية",
    "lx":"الفائدة",
    "fkjg":"المقرض",
    "tpsc":"قرض ائتماني (تحميل صورة)",
    "fwxx":"معلومات السكن",
    "srzm":"إثبات الدخل (علاقة عمل)",
    "yhmx":"كشف حساب بنكي",
    "zjz":"صورة الهوية",
    "yd":"لقد قرأت ووافقت",
    "xy":"التقدم بطلب للحصول على اتفاقية قرض",
    "sqdb":"انقر للتقدم بطلب للحصول على سلاسل قروض",
    "gb":"إغلاق",
    "qd":"حسنًا",
    "ts":"يرجى تحديد التقدم بطلب للحصول على اتفاقية قرض",
    "dbjl":"السجل",
    "hkhth":"رمز الطلب",
    "wsh":"غير مُراجع",
    "yfk":"القرض",
    "sqrq":"مدة الطلب",
    "zq":"الدورة",
    "dbsl":"عدد الأضلاع",
    "zhke":"إجمالي الدفعة",
    "yhkxq":"تفاصيل السداد",
    "bqyhk":"قابل للسداد في الفترة الحالية (USDT)",
    "hktips":"يرجى التأكد من أن الرصيد كافٍ، إذا كان الرصيد غير كافٍ، يرجى إعادة الشحن أولاً ثم السداد",
    "bj":"رأس المال",
    "jie":"الاقتراض",
    "ljhk":"السداد فورًا",
    "qcz":"للإيداع",
    "yebzqxcz":"رصيد غير كافٍ، يُرجى إعادة الشحن أولاً ثم السداد",
    "znj":"رسوم التأخر في السداد",
    "yqts":"أيام التأخر في السداد",
  },
  "hkxq":{
    "dd":"الطلب",
    "fzhkdz":"انسخ عنوان السداد",
    "hkxq":"تفاصيل السداد",
    "zlx":"إجمالي الفائدة",
    "zhk":"إجمالي الدفعات",
    "hkjg":"وكالة السداد",
    "qschkpz":"الرجاء تحميل شهادة السداد",
    "hkpz":"شهادة السداد",
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"الطلب",
    "cj":"الصفقة",
    "jj":"المعلومات",
    "sj":"الوقت",
    "fx":"الاتجاه",
    "jg":"السعر",
    "sl":"الكمية",
    "mr":"الشراء",
    "mc":"البيع",
    "mp":"العطاء",
    "sp":"البيع",
    "slb":"الكمية",
    "fhsj":"تاريخ الإصدار",
    "fhsl":"رقم الإصدار",
    "bps":"الورقة البيضاء",
    "gw":"الموقع الرسمي",
    "fz":"الحد الأدنى",
    "xs":"الساعة",
    "tian":"الأيام",
    "zhou":"الأسبوع",
    "yue":"الشهر",
    "gd":"المزيد",
    "ft":"الرسم البياني الفرعي",
    "zt":"الرسم البياني الرئيسي",
    "sdt":"صورة العمق",
    "zx":"المفضلة",
    "djck":"انقر للعرض",
  },
  "jghy":{
    "jghy":"الخيارات",
    "yxhy":"دائم",
    "mz":"شراء طويل",
    "md":"شراء قصير",
    "gmj":"سعر الشراء",
    "jsj":"سعر التسوية",
    "xj":"السعر الحالي",
    "fx":"الاتجاه",
    "sl":"الحجم",
    "jgsj":"وقت التسليم",
    "gb":"إغلاق",
    "jxxd":"متابعة تقديم طلب",
    "cclb":"قائمة الطلبات",
    "zc":"الحالية",
    "lscc":"التاريخ",
    "qblx":"الكل",
    "yk":"الأرباح",
    "ddqr":"تأكيد الطلب",
    "dqsj":"وقت انتهاء الصلاحية",
    "jssj":"وقت التسليم",
    "sy":"الربح",
    "tzje":"سعر الاستثمار",
    "zdje":"أدنى سعر 0",
    "kyye":"الرصيد",
    "kyye2":"الرصيد",
    "sxf":"الرسوم:",
    "sxfl":"الرسوم",
    "jypz":"الاسم",
    "jyfx":"الاتجاه",
    "qrxd":"تأكيد",
    "fs":"السطر",
    "dqye":"الرصيد الحالي",
  },
  "zhjl":{
    "title":"سجل الأصول",
    "cbtb":"الإيداع والسحب",
    "jymx":"سجل المعاملات",
    "tgyj":"عمولة الترويج",
    "wwc":"تم التراجع عنه",
    "ywc":"تم إكماله",
  },
  "tipsNew":{
    "wjmmts":"استعادة كلمة المرور عن طريق رمز التحقق",
    "qscpztp":"يرجى تحميل صورة القسيمة",
    "emailgsts":"صناديق البريد المدخلة لا تتوافق مع القواعد",
    "telgsts":"رقم الهاتف المحمول غير صحيح",
    "lcmmbyz":"يرجى تأكيد كلمة المرور",
    "zdsl":"الحد الأدنى للكمية",
    "sldydy":"الكمية أكبر من أو تساوي",
    "zxtzsl":"الحد الأدنى للكمية",
    "ddz":"انتظار",
    "xs":"ساعة",
    "min":"الحد الأدنى للمبلغ",
    "max":"الحد الأقصى للمبلغ",
    "yebz":"رصيد غير كافٍ",
    "qsrss":"يرجى إدخال اللوتات",
    "zdss":"الحد الأدنى لللوتات",
    "yjj":"مرفوض",
    "shz":"استرداد",
    "zwkfcz":"هذه العملة غير متاحة للإيداع",
    "jiaoge":"التسليم",
    "zhang":"طويل",
    "die":"قصير",
  },
  "assets": {
    "total":"تحويل الأصول (بالدولار الأمريكي)",
    "avaiable":"متاح",
    "conversion":"التحويل",
    "canuse":"متاح",
    "yczc":"الأصول المخفية كـ 0",
  },
  "status": {
    "statusText":"['failure','waiting','success']",
  },
  "langNew2":{
    "zczgz":"إجمالي الأصول",
    "hgx":"الامتثال",
    "yszc":"سياسة الخصوصية",
    "gywm":"نبذة عنا",
    "zb":"التحكيم بالذكاء الاصطناعي",
    "mnjy":"التداول المحاكى",
    "xbzq":"منطقة العملة في سنغافورة",
    "flzq":"مركز المكافآت",
    "cjmnzhcg":"قم بإنشاء حساب تجريبي بنجاح!",
    "wdzh":"حسابي",
    "yymnzhts":"لديك حساب افتراضي بالفعل، يرجى عدم التسجيل مرة أخرى",
    "tcmnzh":"الخروج من الحساب التجريبي",
    "mnzhgz":"تقييم الحساب التجريبي",
    "mnzh":"الحساب التجريبي",
    "ljdzsb":"فشل الاتصال بالعنوان",
    "ysq":"مصرح به",
  },
  "c2c":{
    "bt":"C2C",
    "bt2":"خدمة الدفع C2C",
    "cjdd":"إنشاء طلب",
    "mblc":"إيداع العملة الورقية",
    "cjydd":"إنشاء طلب مسبق",
    "xmjfk":"الدفع للبائع",
    "tqhb":"سحب العملة الرقمية",
    "ddzt":"حالة الطلب",
    "wdys":"مزايانا",
    "c1":"تداول بالسعر المفضل لديك",
    "c2":"قم بشراء وبيع العملات المشفرة بحرية بالسعر المفضل لديك. قم بالشراء والبيع من العروض الحالية، أو قم بإنشاء إعلان تداول لتحديد السعر المثالي لك.",
    "c3":"رسوم معاملات منخفضة",
    "c4":"تتيح معاملات نظير إلى نظير (C2C) للبائعين تحديد طريقة الدفع التي يريدونها بحرية وبطريقة شفافة، وشراء وبيع العملات المشفرة من خلال أكثر من 700 طريقة دفع بما في ذلك التحويل المصرفي والنقد.",
    "c5":"طرق دفع متعددة",
    "c6":"تتيح تجارة نظير إلى نظير (C2C) للبائعين تحديد طريقة الدفع التي يريدونها بحرية. شراء وبيع العملات المشفرة بأكثر من 700 طريقة دفع، بما في ذلك التحويلات المصرفية والنقد.",
    "wpp":"غير مطابق",
    "ypp":"مطابق",
    "ysx":"منتهية الصلاحية",
    "ddh":"رقم الطلب",
    "mrje":"مبلغ الشراء",
    "mrbz":"عملة الشراء",
    "nssdgj":"الدولة",
    "qsrnssdgj":"يرجى إدخال الدولة",
    "fkrxm":"اسم الدافع",
    "qsrfkrxm":"يرجى إدخال اسم الدافع",
    "yx":"البريد الإلكتروني",
    "qsryx":"يرجى إدخال عنوان بريدك الإلكتروني",
    "mmbz":"نوع الشراء",
    "qxzmmbz":"يرجى تحديد نوع الشراء",
    "qxz":"يرجى تحديد",
    "fkfs":"طريقة الدفع",
    "qtxfkfs":"يرجى ملء طريقة الدفع",
    "zh":"الحساب",
    "fb":"نوع عملة الدفع",
    "qtxfb":"يرجى إدخال نوع عملة الدفع",
    "ngmdje":"مبلغ الشراء",
    "qsrje":"يرجى إدخال المبلغ",
    "wxts":"تذكير حار",
    "dsh":"سيتم مراجعته",
    "ygq":"منتهية الصلاحية",
    "jcwdwt":"مقدمة عن C2C",
    "tjpz":"إرسال القسيمة",
    "ckje":"المبلغ المطابق",
    "qsrckje":"يرجى إدخال المبلغ المطابق",
    "tjzzfb":"نسخة التحويل",
    "tjjzzm":"بطاقة الهوية (الأمامية)",
    "tjjzfm":"بطاقة الهوية (الخلفية)",
    "psts1":"انتبه إلى النقاط التالية عند التصوير",
    "psts2":"يرجى ملاحظة أن حدود الصورة كاملة والخط واضح والسطوع موحد",
    "psts3":"يرجى عدم تحميل صور هوية لا تتطابق مع اسمك",
    "qsczzfb":"يرجى تحميل نسخة من التحويل",
    "qscjzzm":"يرجى تحميل الجزء الأمامي من رخصة القيادة الخاصة بك",
    "qscjzfm":"يرجى تحميل الجانب الخلفي من رخصة القيادة الخاصة بك",
    "tj":"إرسال",
    "je":"تحديد النطاق",
    "ljtg":"وضع الطلب",
    "sp":"فهم DEFI",
    "xq":"التفاصيل",
    "lxkfppdd":"اتصل بخدمة العملاء لمطابقة الطلب",
    "szgj":"البلد",
    "qsrszgj":"الرجاء إدخال بلدك",
    "fkyhmc":"اسم بنك الدفع",
    "qsrfkyhmc":"الرجاء إدخال اسم بنك الدفع",
    "dianhui":"التحويل البنكي/التحويل البنكي الدولي",
    "ccsr":"أدخل هنا",
  },
  "xyf":{
    "title":"درجة الائتمان",
    "pgsj":"وقت التقييم",
  },
  "bbjy":{
    "mr":"شراء",
    "mc":"بيع",
    "mai":"شراء",
    "sell":"بيع",
    "xj":"حد",
    "sj":"السوق",
    "pk":"الموقف",
    "jg":"السعر",
    "sl":"الكمية",
    "ss":"الكمية",
    "mrl":"حجم الشراء",
    "mcl":"حجم البيع",
    "ky":"متوفر",
    "km":"متوفر",
    "ksell":"قابل للتسويق",
    "jye":"المبيعات",
    "dqwt":"التوكيل الحالي",
    "lswt":"التوكيل التاريخي",
    "jj":"معلومات",
    "wtzl":"المجموع",
    "wtjg":"سعر التكليف",
    "ycjl":"حجم التداول المكتمل",
    "cjjj":"متوسط ​​سعر المعاملة",
    "cd":"إلغاء الأمر",
    "xd":"الأمر",
    "wqcj":"صفقة مكتملة",
    "ywc":"مكتملة",
    "ycd":"أمر ملغى",
    "zx":"المفضلة",
    "scjg":"سعر السوق",
    "fhsj":"تاريخ الإصدار",
    "fhsl":"رقم الإصدار",
    "bps":"الورقة البيضاء",
    "gw":"الموقع الرسمي",
    "qx":"إلغاء",
    "bbjy":"التبادل",
  },
  "hyjy":{
    "mai":"الشراء",
    "sell":"البيع",
    "kc":"المراكز المفتوحة",
    "pc":"إغلاق المراكز",
    "cc":"المراكز",
    "kp":"إغلاق",
    "kpc":"إغلاق قصير",
    "kcc":"المراكز",
    "kkd":"فتح طويل",
    "kpd":"إغلاق طويل",
    "kkk":"فتح قصير",
    "xj":"حد",
    "sj":"السوق",
    "xjwt":"أمر محدد",
    "sjwt":"سعر السوق",
    "pk":"المركز",
    "jg":"السعر",
    "sl":"الكمية",
    "gg":"الرافعة",
    "tzgg":"رافعة التحكم",
    "ggbs":"الرافعة المالية",
    "mrl":"حجم الشراء",
    "ky":"المتوفر",
    "jye":"المبيعات",
    "dqwt":"التعهدات الحالية",
    "lswt":"التعهدات التاريخية",
    "ptwt":"التعهدات العادية",
    "dqwtmr":"التعهدات الحالية(شراء)",
    "dqwtmc":"التعهدات الحالية(بيع)",
    "hywt":"التعهدات التعاقدية",
    "jj":"المعلومات",
    "wtzl":"الإجمالي",
    "wtjg":"سعر التعهد",
    "ycjl":"حجم التداول المكتمل",
    "cjjj":"متوسط ​​سعر المعاملة",
    "qbcd":"سحب جميع الطلبات",
    "cd":"إلغاء الطلب",
    "xd":"الطلب",
    "wqcj":"صفقة كاملة",
    "ywc":"مكتملة",
    "ycd":"أمر ملغى",
    "zx":"المفضلة",
    "scjg":"سعر السوق",
    "fhsj":"تاريخ الإصدار",
    "fhsl":"رقم الإصدار",
    "bps":"الورقة البيضاء",
    "gw":"الموقع الرسمي",
    "mrzd":"افتتاح طويل",
    "mrpk":"إغلاق قصير",
    "mczk":"افتتاح قصير",
    "mcpd":"إغلاق طويل",
    "mrkdkz":"افتتاح طويل (صاعد)",
    "mrpkkz":"إغلاق قصير (صاعد)",
    "mckkkd":"افتتاح قصير (هابط)",
    "mcpdkd":"إغلاق طويل (هابط)",
    "yxhy":"عقد دائم",
    "dc":"المراكز الطويلة",
    "kcjj":"متوسط ​​سعر المركز المفتوح(BUSDT)",
    "wsxyl":"الربح غير المحقق(BUSDT)",
    "ygqpj":"التعادل القوي المقدر(BUSDT)",
    "syl":"يومي الدخل",
    "cwbzj":"هامش المركز (BUSDT)",
    "cw":"المراكز (عدد)",
    "cwjz":"قيمة المركز (BUSDT)",
    "bzjl":"معدل الهامش",
    "kpz":"الإغلاق (عدد)",
    "bdzs":"المؤشر الأساسي",
    "tzbzj":"ضبط الهامش",
    "zyzs":"جني الأرباح وإيقاف الخسارة",
    "zjbzj":"زيادة الهامش",
    "jsbzj":"تقليل الهامش",
    "tyhy":"عقد الخبرة",
    "ccz":"المركز (رقم)",
    "cwbzjt":"هامش المركز (TBTC)",
    "zdzjbzj":"أقصى زيادة في الهامش (TBTC)",
    "zjbzjt":"زيادة الهامش (TBTC)",
    "zhang":"الكمية",
    "qblx":"جميع الأنواع",
    "qb":"جميع",
    "ccjg":"سعر المراكز",
    "ccsl":"كمية المراكز",
    "yk":"الربح والخسارة",
    "ccsj":"وقت المراكز",
    "zy":"جني الأرباح",
    "zs":"إيقاف الخسارة",
    "zje":"المبلغ الإجمالي",
    "kcs":"كمية المراكز المفتوحة",
    "kcjg":"سعر المراكز المفتوحة",
    "ss":"العقود",
    "hand":"1 عقود =",
    "qx":"إلغاء",
    "qr":"موافق",
  },
  "bbjyNew":{
    "jylx":"أنواع",
    "jyze":"المبلغ",
  },
  "langNew3":{
    "bzxq":"تفاصيل تحريك الطوب",
    "znbz":"الذكاء الاصطناعي الكمي تحريك الطوب الذكي",
    "apits":"الاتصال بسلاسة بواجهات برمجة التطبيقات لأكثر من 200 بورصة حول العالم",
    "jr":"الانضمام",
    "gn":"الوظيفة",
    "lhjs":"مقدمة إلى تحديد كمية الأرباح",
    "jqrts":"كيف تعمل الروبوتات؟",
    "sctj":"إحصائيات السوق",
    "scqk":"ظروف السوق",
    "jiaoge":"التسليم",
    "zhang":"الارتفاع",
    "die":"الانخفاض",
    "sz":"الإعدادات",
    "qbcp":"جميع المنتجات",
    "jrlh":"الانضمام إلى تقدير الذكاء الاصطناعي",
    "sywd":"0 مخاطرة، عوائد مستقرة",
    "bzbz":"نوع العملة المشفرة",
  },
  "sztkmm":{
    "title":"تعيين كلمة مرور السحب",
    "dlmm":"كلمة مرور تسجيل الدخول",
    "dlmmts":"يرجى إدخال كلمة مرور تسجيل الدخول",
    "xmm":"كلمة مرور جديدة",
    "mmts":"طول كلمة المرور 6 أرقام",
    "qrmm":"تأكيد كلمة المرور",
    "qr":"موافق",
    "qd":"موافق",
    "sztkts":"نصيحة: يرجى الانتقال إلى مركز الأمان لتعيين كلمة مرور المعاملة",
  },
  "bzhl":{
    "title":"أرباح الأسهم",
    "gz":"القواعد",
    "tgdd":"أمر الضمان",
    "zztgdzj":"الأموال في عهدة",
    "yjjrsy":"تقدير يومي",
    "ljsy":"إجمالي الدخل",
    "tgzdd":"أمر في عهدة",
    "cljxcp":"منتجات الحملة الاستراتيجية",
    "dbxe":"الحد الأقصى",
    "rsyl":"معدل العائد اليومي",
    "zq":"دورة الطلب",
    "qmr":"اذهب واشتر",
    "bbzhzc":"أصول الحساب",
    "zcc":"إجمالي الأصول (USDT)",
    "dd":"الطلبات",
    "buy":"شراء",
    "jxcp":"المنتجات المميزة",
    "ckdd":"التحقق من الطلب",
    "gd":"المزيد",
    "xzbzts":"بسيط وآمن. يمكن تحديد أرباح الأسهم بعملات متعددة",
    "qtbz":"عملات أخرى",
    "dj":"المستوى",
    "cjwt":"المشاكل الشائعة",
    "ddsl":"كمية الطلب",
    "sl":"المبلغ",
  },
  "bzhlgm":{
    "title":"الأرباح من إزالة الطوب",
    "bzhld":"الأرباح من إزالة الطوب USDT",
    "qtzq":"دورة USDT التي تستمر 7 أيام",
    "rsyl":"معدل العائد اليومي",
    "lczq":"الدورة المالية",
    "dbxe":"الحد الأقصى",
    "pxsj":"وقت صرف الأرباح",
    "mr":"يوميًا",
    "dqfh":"العائد عند الاستحقاق",
    "tgzj":"رأس مال الحراسة",
    "tqsh":"الاسترداد المبكر",
    "yjsy":"الدخل المتوقع (USDT)",
    "kyzc":"الأصول المتاحة (USDT)",
    "cpjs":"حول منتجاتنا",
    "tgje":"أدخل المبلغ",
    "qsrtgje":"الرجاء إدخال مبلغ الحراسة",
    "qb":"الكل",
    "rm":"انقر هنا",
    "cpzq":"دورة المنتج",
    "jxr":"تاريخ حساب الفائدة",
    "jiexr":"تاريخ تسوية الفائدة",
    "yjdzr":"تاريخ الوصول المقدر",
    "gz":"معرفة القواعد والفوائد",
  },
  "bzhlwdtg":{
    "title":"حالة الطلب",
    "tgz":"قيد الاحتجاز",
    "ywc":"مكتمل",
    "ysh":"مسترد",
    "tgje":"مبلغ الاحتجاز/مدة الاحتجاز",
    "rsyl":"معدل الإرجاع اليومي",
    "yhl":"مربح",
    "xdsj":"وقت الطلب",
    "sh":"الاسترداد",
    "ddxq":"تفاصيل الطلب",
    "ddh":"رقم الطلب",
    "syts":"المتبقي",
    "ddztxq":"تفاصيل حالة الطلب",
  },
  "langNew4":{
    "kp":"الافتتاح",
    "zuoshou":"تم الاستلام بالأمس",
    "zg":"الأعلى",
    "zd":"الأدنى",
    "dqjg":"السعر الحالي",
    "pcjg":"سعر الإغلاق",
    "gd":"الأمر المعلق",
    "gdj":"سعر الأمر المعلق",
    "gdjg":"سعر الطلب المعلق",
    "xfbzj":"مطلوب وديعة تأمين",
    "ksrfw":"نطاق الإدخال المتاح",
    "shou":"العقود",
    "fdjyk":"صافي الربح والخسارة العائمة",
    "pcsl":"كمية الإغلاق",
    "cx":"إلغاء",
    "qrpc":"تأكيد لإغلاق المركز",
    "sx":"تصفية",
    "cz":"إعادة تعيين",
    "zdl":"علم",
    "kccg":"تم فتح مركز بنجاح!",
    "xzfx":"اختيار الاتجاه",
    "lx":"النوع",
    "xgcc":"تعديل المركز",
    "szzyzs":"تعيين وقف الربح ووقف الخسارة",
    "szhb":"العملات المشفرة",
    "gjs":"المعدن",
    "yy":"الخام",
    "jy":"التداول",
    "jmhb":"العملات المشفرة",
    "gdsj":"وقت الطلب المعلق",
    "gdsl":"كمية الطلب المعلق",
    "fs":"الوقت",
   },
   "deals": {
  	"issue_time":"الوقت",
    "issue_number":"العدد",
    "white_book":"الكتاب",
    "weburl":"عنوان URL",
    "video_url":"الفيديو",
    "introduction":"المعلومات",
    "onhand":"يد واحدة تساوي",
    "position":"الموقف",
    "leverorder":"أوامر الرافعة المالية",
    "leverposition":"الموقف بالرافعة المالية",
    "inputprice":"إدخال السعر",
    "inputmul":"إدخال مضاعف",
    "selectmul":"اختر مضاعفًا",
    "onehand":"يد واحدة تساوي",
    "hand":"عدد الأيدي المتداولة",
    "marketval":"القيمة السوقية",
    "bond":"السند",
    "service":"رسوم الخدمة",
    "balance":"الرصيد",
    "type":"النوع",
    "risk":"معدل المخاطرة",
    "total":"إجمالي الربح",
    "onekey":"إغلاقه",
    "makemore":"(طويل)",
    "makeless":"(قصير)",
    "current":"أوامر الفتح",
    "all":"الكل",
    "weing":"في العمولة",
    "tding":"التداول",
    "ping":"الإغلاق",
    "pied":"المغلق",
    "ceiled":"السحب",
    "weprice":"سعر العمولة",
    "oprice":"سعر الافتتاح",
    "nowprice":"السعر الحالي",
    "zyprice":"سعر إيقاف الأرباح",
    "zsprice":"سعر إيقاف الخسارة",
    "canbond":"الهامش المتاح",
    "optime":"وقت الافتتاح",
    "pgtime":"وقت الإغلاق",
    "znum":"الكمية المحولة",
    "gprice":"رسوم الليلة",
    "pcang":"إغلاق",
    "revoke":"رسوم السحب",
    "fee":"سعر السوق الأمثل",
    "you":"جني الأرباح وإيقاف الخسارة",
  },
  "zyzs":{
    "title":"جني الأرباح",
    "zy":"إيقاف الخسارة",
    "zs":"يرجى إدخال سعر جني الأرباح",
    "qsrzyjg":"يرجى إدخال سعر إيقاف الخسارة",
    "qsrzsjg":"الرجاء إدخال سعر وقف الخسارة",
    "cfjglx":"نوع السعر المحفز",
    "zsjg":"سعر المؤشر",
    "scjg":"سعر السوق",
    "pcfs":"طرق إغلاق المراكز",
    "kpcw":"إغلاق",
    "qbcw":"جميع المراكز",
    "wxts":"يرجى ملاحظة أن إغلاق المراكز بسعر السوق قد يؤدي إلى احتمالية الفشل في إصدار أمر بسعر السوق، أو تحقيق الربح/وقف الخسارة بنجاح بسبب التقلبات الحادة في السوق وغيرها من المشاكل.",
    "cont":"",
    "qr":"موافق",
  },
  "level1": {
    "name":"الاسم الحقيقي",
    "idcard":"نوع الشهادة",
    "address":"عنوان الإقامة الحالي",
    "bank_number":"رقم البنك",
    "wc":"موافق",
    "name_nodata":"لا يمكن أن يكون الاسم فارغًا",
    "id_card_nodata":"لا يمكن أن يكون رقم الشهادة فارغًا",
    "address_nodata":"لا يمكن أن يكون العنوان فارغًا",
    "bank_number_nodata":"لا يمكن ترك رقم البطاقة المصرفية فارغًا",
    "input-username":"يرجى إدخال اسمك الحقيقي",
    "zjhm":"رقم الشهادة",
    "input-idcard":"يرجى إدخال رقم الشهادة",
    "input-address":"يرجى إدخال عنوانك",
    "zjlx":"أنواع بطاقات الهوية الصالحة",
    "qxzzjlx":"يرجى تحديد أنواع بطاقات الهوية الصالحة",
    "sfz":"بطاقة الهوية",
    "hz":"جواز السفر",
    "jsz":"رخصة القيادة",
    "lxz":"شهادة الدراسة في الخارج",
    "zfbzh":"حساب Alipay",
    "qsrzfbzh":"يرجى إدخال حساب Alipay الخاص بك",
    "khh":"فتح حساب",
    "qsrkhh":"يرجى إدخال حساب البنك الخاص بك",
    "yhkh":"رقم البطاقة المصرفية",
    "qsryhkh":"يرجى إدخال رقم البطاقة المصرفية الخاصة بك",
    "zfzh":"حساب الدفع",
    "qxzzfzh":"الرجاء اختيار حساب الدفع",
    "gjlb":"قائمة البلدان",
    "qxzgjlb":"الرجاء تحديد البلد/المنطقة",
    "gjhdq":"البلد/المنطقة",
    "qtxgj":"الرجاء ملء البلد/المنطقة",
  },
  "gjrz":{
    "title":"مصادقة KYC",
    "t1":"1. يتم دعم الصور التي يقل حجمها عن 8 ميجا بايت وبتنسيقات JPG أو JPEG أو PNG.",
    "t2":"2. يجب أن تكون صور وثيقة الهوية واضحة ولا يجوز تعديلها أو حجبها. يجب أن تكون الصورة الشخصية ورقم الوثيقة واسم حامل الوثيقة مرئية بوضوح.",
    "t3":"3. يجب التقاط الصور بدون أي غطاء للرأس، ويوصى بعدم استخدام المكياج. يجب أن تكون ملامح وجه حامل الوثيقة واضحة وقابلة للتعرف عليها، ويجب أن تكون ذراعيه مكشوفة بالكامل.",
    "t4":"موافق",
    "bh":"رفض",
    "shz":"قيد المراجعة",
    "shtg":"تمت الموافقة",
    "nyrzcg":"لقد تم اعتمادك بنجاح",
    "sczjz":"تحميل صور الهوية",
    "sczjzmz":"تحميل صورة للوجه الأمامي لوثيقة الهوية",
    "sczjbmz":"تحميل صورة للظهر لوثيقة الهوية",
    "scgrqmz":"تحميل المستندات والتوقيع الشخصي",
    "wdtjr":"الموصي الخاص بي",
    "tjrid":"معرف الموصي",
    "qsrtjrid":"يرجى إدخال معرف الموصي",
    "idbcz":"معرف المرجع غير موجود",
    "tjcg":"تم الإرسال بنجاح",
    "tjridts":"لا يمكن ملء معرف الموصي بنفسك",
    "qsrzh":"يرجى إدخال الحساب",
    "dl":"تسجيل الدخول",
    "jc":"ضعيف",
    "yb":"عام",
    "yx":"ممتاز",
    "ldjsqh":"عقود آجلة في بورصة لندن للمعادن",
    "wh":"الصرف الأجنبي",
  },
  "newReg":{
    "sjh":"الجوال",
    "yx":"البريد الإلكتروني",
    "yqm":"رمز الدعوة",
    "yqm2":"رمز الدعوة (اختياري)",
    "cjzh":"إنشاء حساب",
    "sysjhzyx":"التسجيل باستخدام رقم الهاتف المحمول/البريد الإلكتروني",
    "sj":"الجوال",
    "yhxy":"<اتفاقية المستخدم>",
    "yhxy2":"لقد قرأت ووافقت على  و  <اتفاقية المستخدم>",
    "hmyzh":"ليس لديك حساب حتى الآن؟",
    "qzc":"التسجيل",
    "qbdl":"تسجيل الدخول إلى المحفظة",
    "qyqbfw":"يرجى استخدام تطبيق المحفظة للوصول",
    "dc":"تسجيل الخروج",
    "cycs":"عدد المشاركات"
  },
}



// WEBPACK FOOTER //
// ./src/utils/lang/ar.js